
import {interval as observableInterval,  BehaviorSubject ,  Subscription } from 'rxjs';

import {defaultIfEmpty, map, takeWhile} from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Component, OnInit, OnDestroy, Input, Output } from '@angular/core';
import { EventEmitter } from '@angular/core';

@Component({
    selector: 'countdown-timer',
    template:
        `<ng-container *ngIf="time1$ | async;let time1;">
    <div class="clockdiv">
    <div> 
    <span>{{(time1$ | async)?.days}}</span>
    <div class="smalltext">Days</div> 
    </div>
  <div>
    <span>{{(time1$ | async)?.hours}}</span>
    <div class="smalltext">Hrs</div>
  </div>
  <div>
    <span>{{(time1$ | async)?.minutes}} </span>
    <div class="smalltext">Mins</div>
  </div>
  <div>
    <span>{{(time1$ | async)?.seconds}}</span>
    <div class="smalltext">Secs</div>
  </div>
      <!--<h4 class="panel-title">{{(time1$ | async)?.days}} d : {{(time1$ | async)?.hours}} h : {{(time1$ | async)?.minutes}} m : {{(time1$ | async)?.seconds}} s </h4>-->
     </div>
      </ng-container>`,
    styleUrls: ['./countdown-timer.component.css']
})

export class CountdownTimerComponent implements OnInit, OnDestroy {

    private _timerInput = new BehaviorSubject<TimerInput>({ resumeLapse: true });
    @Input() set timerInput(value) {
        if (value.resumeLapse == null || value.resumeLapse == undefined) value.resumeLapse = true;
        this._timerInput.next(value);
    }
    get timerInput() {
        return this._timerInput.getValue();
    }

    @Output() isExpired: EventEmitter<boolean> = new EventEmitter<boolean>();
    private timeExpired: boolean = false;
    time1$: Observable<Time>;
    timerInput$: Subscription;
    countDown: Time = { days: 0, hours: 0, minutes: 0, seconds: 0 };
    private now: number;

    ngOnInit() {
        this.timerInput$ = this._timerInput.pipe(
            takeWhile(t => (t.endTime && t.endTime != null)))
            .subscribe(s => {
                this.time1$ = this.timer(this.timerInput);
            });
    }

    private createTimeObject(timerInput: TimerInput): Time {
        var utcTimestamp = new Date().getTime() + (new Date().getTimezoneOffset() * 60000);
        this.now = timerInput.startTime ? new Date(timerInput.startTime).getTime() :
            (timerInput.isUtcTime && timerInput.isUtcTime == true) ? utcTimestamp : new Date().getTime();
        const distance = Math.abs(new Date(timerInput.endTime).getTime() - this.now);

        let time: Time = { days: 0, hours: 0, minutes: 0, seconds: 0 };
        time.days = this.pad(Math.floor(distance / (1000 * 60 * 60 * 24)));
        time.hours = this.pad(Math.floor((distance / (1000 * 60 * 60)) % 24));
        time.minutes = this.pad(Math.floor((distance / (1000 * 60)) % 60));
        time.seconds = this.pad(Math.floor((distance / 1000) % 60));

        if (this.timeExpired==false && new Date(timerInput.endTime).getTime() < this.now) {
            this.isExpired.emit(true);
            this.timeExpired=true;
        }

        //Actual met time and scheduled met time calculation (optional)
        if (timerInput.actualEndTime) {
            let actulaEndTimeStamp = new Date(timerInput.actualEndTime).getTime();
            let endTimeStamp = new Date(timerInput.endTime).getTime();
            let actualDifference = Math.abs(endTimeStamp - actulaEndTimeStamp);
            this.countDown.days = this.pad(Math.floor(actualDifference / (1000 * 60 * 60 * 24)));
            this.countDown.hours = this.pad(Math.floor((actualDifference / (1000 * 60 * 60)) % 24));
            this.countDown.minutes = this.pad(Math.floor((actualDifference / (1000 * 60)) % 60));
            this.countDown.seconds = this.pad(Math.floor((actualDifference / 1000) % 60));
        }
        else
            this.countDown = time.seconds >= 0 ? time : { days: this.pad(0), hours: this.pad(0), minutes: this.pad(0), seconds: this.pad(0) };

        return time;
    }
    private pad(digit: any) {
        return (digit < 10 && digit > -1) ? '0' + digit : digit;
    }
    timer(timerInput: TimerInput): Observable<Time> {
        return observableInterval(1000).pipe(
            map(() => this.createTimeObject(timerInput)),
            takeWhile(counter => (!timerInput.interruption
                && (timerInput.resumeLapse ? (!timerInput.actualEndTime || new Date(timerInput.actualEndTime).getTime() >= this.now /*new Date().getTime()*/) : new Date(timerInput.endTime).getTime() > this.now))),
            defaultIfEmpty(this.countDown),);
    }

    ngOnDestroy() {
        try {
            this.timerInput$.unsubscribe();
        } catch (err) { }
    }
}
export interface TimerInput {
    startTime?: Date;
    endTime?: Date;
    actualEndTime?: Date;
    isUtcTime?: boolean;
    interruption?: boolean;
    resumeLapse?: boolean;
}
interface Time {
    days: number;
    hours: number;
    minutes: number;
    seconds: number;
}